import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getPlanVente = async famille => {
    const uri = famille === null
        ? '/service/planVente'
        : `/service/planVente/${famille}`
    const articles = await axios.get(uri)
        .catch((e) => {
            throw new CustomException(e, 'Error fetching familly')
        })
    return articles.data
}

export const getRootCategories = async () => {
    const categories = await axios.get('/service/planVente/rootCategories')
    .catch((e) => {
        throw new CustomException(e, 'Error fetching root categories')
    })

    return categories.data
}
